export default __webpack_public_path__ + "ubisoftsans-bold.woff2";